import React from "react";
import AuthUser from "./models/auth-user";

interface UserContext {
  loggedInUser: undefined | AuthUser;
  setLoggedInUser: React.Dispatch<React.SetStateAction<undefined | AuthUser>>;
}

// @ts-ignore
export const UserContext = React.createContext<UserContext>();
